import { useEffect, useState } from "react";

const calc = (targetISO) => {
  const diff = Math.max(0, new Date(targetISO).getTime() - Date.now());
  return {
    d: Math.floor(diff / 86400000),
    h: Math.floor(diff / 3600000) % 24,
    m: Math.floor(diff / 60000) % 60,
    s: Math.floor(diff / 1000) % 60,
  };
};

export function useCountdown(targetISO) {
  const [t, setT] = useState(() => calc(targetISO));
  useEffect(() => {
    const i = setInterval(() => setT(calc(targetISO)), 1000);
    return () => clearInterval(i);
  }, [targetISO]);
  return t;
}
